/* Build Stuff 2026 · inner pages: speaker filter, program tabs + filters, shared side panel (session ↔ speaker). No dependencies. */
(function () {
  'use strict';

  function debounce(fn, ms) { var t; return function () { var a = arguments, s = this; clearTimeout(t); t = setTimeout(function () { fn.apply(s, a); }, ms); }; }
  function esc(str) { return String(str == null ? '' : str).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function paragraphs(str) { return String(str || '').split('\n').filter(function (x) { return x.trim(); }).map(function (x) { return '<p>' + esc(x) + '</p>'; }).join(''); }

  /* ---------- data: sessions + speakers, loaded once (inline JSON in previews, asset in the theme) ---------- */
  var data = null, loading = null;
  function loadData(src) {
    if (data) return Promise.resolve(data);
    if (loading) return loading;
    var inline = document.getElementById('bs-sessions-inline');
    if (inline) { try { data = JSON.parse(inline.textContent); } catch (e) { data = { sessions: {}, speakers: {} }; } return Promise.resolve(data); }
    if (!src || typeof fetch !== 'function') { data = { sessions: {}, speakers: {} }; return Promise.resolve(data); }
    loading = fetch(src).then(function (r) { return r.json(); }).then(function (d) { data = d; return d; }).catch(function () { data = { sessions: {}, speakers: {} }; return data; });
    return loading;
  }
  function photoUrl(base, file) {
    if (!file) return '';
    if (file.indexOf('data:') === 0) return file;
    if (!base) return '';
    return base.replace(/[^\/]+(\?.*)?$/, '') + file;
  }

  /* ---------- side panel with two views ---------- */
  function initPanel(root) {
    var dialog = root.querySelector('[data-panel]');
    if (!dialog || dialog.dataset.ready) return null;
    dialog.dataset.ready = 'true';
    var body = dialog.querySelector('[data-dialog-body]');
    var back = dialog.querySelector('[data-panel-back]');
    var page = root.querySelector('.aoa-program-page, .aoa-speakers-page');
    var src = page && page.dataset.sessionsSrc, base = page && page.dataset.spkBase;
    var stack = [], lastFocus = null;

    function speakerChip(id, d) {
      var p = d.speakers[id]; if (!p) return '';
      var img = photoUrl(base, p.photo);
      var ini = p.name.split(' ').map(function (w) { return w[0]; }).filter(Boolean).slice(0, 2).join('').toUpperCase();
      return '<button type="button" class="pnl__chip" data-open-speaker="' + esc(id) + '">' + (img ? '<img src="' + esc(img) + '" alt="" width="224" height="224" loading="lazy">' : '<span class="pnl__ini">' + esc(ini) + '</span>') + '<span><b>' + esc(p.name) + '</b><small>' + esc(p.tagline || p.company || '') + '</small></span><i aria-hidden="true">&rarr;</i></button>';
    }
    function sessionRow(id, d) {
      var s = d.sessions[id]; if (!s) return '';
      return '<button type="button" class="pnl__row" data-open-session="' + esc(id) + '"><b>' + esc(s.title) + '</b><span class="aoa-mono">' + esc(s.when) + '</span><i aria-hidden="true">&rarr;</i></button>';
    }
    function tags(list, cls) { return (list || []).map(function (t) { return '<span class="' + cls + '">' + esc(t) + '</span>'; }).join(''); }

    function renderSession(id, d) {
      var s = d.sessions[id]; if (!s) return '<p class="aoa-mono">Session details coming soon.</p>';
      var html = '<p class="aoa-mono pnl__kicker">' + esc(s.when) + ' · ' + esc(s.fmt) + '</p><h3 class="pnl__title">' + esc(s.title) + '</h3>';
      html += '<div class="prg__tracks pnl__tags">' + (s.agencies || []).map(function (a) { return '<span class="prg__lens prg__ag prg__ag--' + a[0] + '">' + esc(a) + '</span>'; }).join('') + tags(s.tracks, '') + '</div>';
      if (s.speakers && s.speakers.length) html += '<div class="pnl__section"><p class="aoa-index">' + (s.speakers.length > 1 ? 'Speakers' : 'Speaker') + ' · tap for profile</p>' + s.speakers.map(function (i) { return speakerChip(i, d); }).join('') + '</div>';
      html += '<div class="pnl__body">' + (paragraphs(s.desc) || '<p class="aoa-mono">Details coming soon.</p>');
      if (s.level) html += '<p class="aoa-mono">Level · ' + esc(s.level) + '</p>';
      if (s.why) html += '<p class="prg__why"><b>Why it matters</b>' + esc(s.why) + '</p>';
      if (s.take) html += '<p class="prg__take"><b>Takeaways</b>' + esc(s.take).replace(/\n/g, '<br>') + '</p>';
      return html + '</div>';
    }
    function renderSpeaker(id, d) {
      var p = d.speakers[id]; if (!p) return '<p class="aoa-mono">Speaker profile coming soon.</p>';
      var img = photoUrl(base, p.photo);
      var html = '<div class="spkd__head">' + (img ? '<img class="spkd__img" src="' + esc(img) + '" alt="' + esc(p.name) + '" width="224" height="224">' : '<span class="spkd__img spkd__img--initials" aria-hidden="true">' + esc(p.name.split(' ').map(function (w) { return w[0]; }).slice(0, 2).join('')) + '</span>')
        + '<div><p class="aoa-index">' + (p.keynote ? 'Keynote speaker' : 'Speaker') + '</p><h3 class="spkd__name">' + esc(p.name) + '</h3><p class="aoa-mono spkd__meta">' + esc(p.company) + (p.country ? ' · ' + esc(p.country) : '') + '</p></div></div>';
      if (p.tagline) html += '<p class="pnl__tagline">' + esc(p.tagline) + '</p>';
      html += '<div class="spkd__bio">' + paragraphs(p.bio) + '</div>';
      if (p.sessions && p.sessions.length) html += '<div class="pnl__section"><p class="aoa-index">' + (p.sessions.length > 1 ? 'Sessions' : 'Session') + ' · tap for details</p>' + p.sessions.map(function (i) { return sessionRow(i, d); }).join('') + '</div>';
      if (p.links && p.links.length) html += '<div class="spkd__links">' + p.links.map(function (l) { return '<a href="' + esc(l[1]) + '" target="_blank" rel="noopener">' + esc(l[0]) + '</a>'; }).join('') + '</div>';
      return html;
    }
    function show(view, id, push) {
      if (push !== false) stack.push([view, id]);
      body.innerHTML = '<p class="aoa-mono">Loading…</p>';
      body.scrollTop = 0;
      if (back) back.hidden = stack.length < 2;
      if (!dialog.open) { if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', ''); }
      loadData(src).then(function (d) {
        body.innerHTML = view === 'speaker' ? renderSpeaker(id, d) : renderSession(id, d);
        body.scrollTop = 0;
        var h = body.querySelector('h3'); if (h) { h.setAttribute('tabindex', '-1'); h.focus(); }
      });
    }
    function open(view, id, trigger) { lastFocus = trigger || document.activeElement; stack = []; show(view, id); }
    function close() {
      if (typeof dialog.close === 'function' && dialog.open) dialog.close(); else dialog.removeAttribute('open');
    }
    dialog.addEventListener('click', function (e) {
      var sp = e.target.closest('[data-open-speaker]'); if (sp) { show('speaker', sp.dataset.openSpeaker); return; }
      var ss = e.target.closest('[data-open-session]'); if (ss) { show('session', ss.dataset.openSession); return; }
      if (e.target.closest('[data-panel-back]')) { stack.pop(); var prev = stack[stack.length - 1]; if (prev) show(prev[0], prev[1], false); return; }
      if (e.target === dialog || e.target.closest('[data-dialog-close]')) close();
    });
    dialog.addEventListener('close', function () { stack = []; if (lastFocus && lastFocus.focus) lastFocus.focus(); });
    return { open: open };
  }

  /* ---------- Speakers page ---------- */
  function initSpeakers(root, panel) {
    var grid = root.querySelector('[data-spk-grid]');
    if (!grid || grid.dataset.ready) return;
    grid.dataset.ready = 'true';
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.spk'));
    var search = root.querySelector('[data-spk-search]');
    var track = root.querySelector('[data-spk-track]');
    var count = root.querySelector('[data-spk-count]');
    var empty = root.querySelector('[data-spk-empty]');
    function apply() {
      var q = (search && search.value || '').trim().toLowerCase();
      var t = track && track.value || '';
      var shown = 0;
      cards.forEach(function (c) {
        var ok = (!q || c.dataset.search.indexOf(q) !== -1) && (!t || ('|' + c.dataset.tracks + '|').indexOf('|' + t + '|') !== -1);
        c.hidden = !ok; if (ok) shown++;
      });
      if (count) count.textContent = shown + (shown === 1 ? ' speaker' : ' speakers');
      if (empty) empty.hidden = shown !== 0;
    }
    if (search) search.addEventListener('input', debounce(apply, 120));
    if (track) track.addEventListener('change', apply);
    grid.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-open-speaker]');
      if (btn && panel) panel.open('speaker', btn.dataset.openSpeaker, btn);
    });
  }

  /* ---------- Program page ---------- */
  function initProgram(root, panel) {
    var tabs = root.querySelectorAll('[data-day-tab]');
    if (!tabs.length || root.dataset.prgReady) return;
    root.dataset.prgReady = 'true';
    var panels = root.querySelectorAll('[data-day-panel]');
    var search = root.querySelector('[data-prg-search]');
    var track = root.querySelector('[data-prg-track]');
    var room = root.querySelector('[data-prg-room]');
    var agBtns = root.querySelectorAll('[data-agency-filter]');
    var count = root.querySelector('[data-prg-count]');
    var empty = root.querySelector('[data-prg-empty]');
    var agencies = [];

    function showDay(i, fromUser) {
      tabs.forEach(function (t, k) { t.setAttribute('aria-selected', k === i ? 'true' : 'false'); t.tabIndex = k === i ? 0 : -1; });
      panels.forEach(function (p, k) { p.hidden = k !== i; });
      apply();
      if (fromUser) { try { history.replaceState(null, '', '#aoa-day-' + (i + 1)); } catch (e) {} }
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { showDay(i, true); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          var n = (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          showDay(n, true); tabs[n].focus();
        }
      });
    });
    function apply() {
      var q = (search && search.value || '').trim().toLowerCase();
      var t = track && track.value || '';
      var r = room && room.value || '';
      var active = null;
      panels.forEach(function (p) { if (!p.hidden) active = p; });
      if (!active) return;
      var shown = 0;
      var filtering = !!(q || t || r || agencies.length);
      active.querySelectorAll('.prg-row:not(.prg-row--head)').forEach(function (row) {
        var visible = 0;
        row.querySelectorAll('.prg').forEach(function (s) {
          var ok = (!q || s.dataset.search.indexOf(q) !== -1)
            && (!t || ('|' + s.dataset.tracks + '|').indexOf('|' + t + '|') !== -1)
            && (!r || s.dataset.room === r)
            && (!agencies.length || agencies.some(function (a) { return ('|' + (s.dataset.agency || '') + '|').indexOf('|' + a + '|') !== -1; }));
          s.classList.toggle('is-dim', filtering && !ok); if (ok) visible++;
        });
        row.querySelectorAll('.prg-time, .prg, .prg-empty').forEach(function (el) { el.hidden = visible === 0; });
        shown += visible;
      });
      if (count) count.textContent = shown + (shown === 1 ? ' session' : ' sessions');
      if (empty) empty.hidden = shown !== 0;
    }
    if (search) search.addEventListener('input', debounce(apply, 120));
    if (track) track.addEventListener('change', apply);
    if (room) room.addEventListener('change', apply);
    agBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        var v = b.dataset.agencyFilter, i = agencies.indexOf(v);
        if (i === -1) agencies.push(v); else agencies.splice(i, 1);
        b.setAttribute('aria-pressed', i === -1 ? 'true' : 'false');
        apply();
      });
    });
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('.prg[data-session-id]');
      if (btn && panel) panel.open('session', btn.dataset.sessionId, btn);
    });
    var m = /#aoa-day-(\d)/.exec(location.hash);
    showDay(m ? Math.min(Math.max(parseInt(m[1], 10) - 1, 0), tabs.length - 1) : 0);
  }

  function boot() {
    document.querySelectorAll('.aoa--page').forEach(function (root) {
      var panel = initPanel(root) || root.__aoaPanel;
      root.__aoaPanel = panel;
      initSpeakers(root, panel); initProgram(root, panel);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
